<template lang='pug'>
  section
    s-page-title(title='Преимущества')
    v-card
      v-data-table(
        :loading='isLoading'
        :headers='headers'
        :items='list'
        :hide-actions='true'
      )
        template(slot='items' slot-scope='props')
          tr(class='with-pointer' @click='onEdit(props.item)')
            td(data-label='ID') {{ props.item.id }}
            td(data-label='Название') {{ props.item.name }}
              div(v-if='props.item.top_name' class="subtitle") {{props.item.top_name }}
              div(v-if='props.item.sub_name' class="subtitle") {{  props.item.sub_name }}
            td {{ props.item.uniqueness_name }}
            td(data-label='Объекты: всего/опубликованных') {{ props.item.assignments_total_count }} / {{ props.item.assignments_count }}
</template>

<script>
import http from '@/http'
export default {
  data: () => ({
    list: [],
    isLoading: false,
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
      },
      {
        text: 'Название',
        align: 'left',
        value: 'name',
        width: '60%',
      },
      {
        text: "Уникальность",
        align: "left",
        sortable: false
      },
      {
        text: 'Объекты: всего/опубликованных',
        align: 'left',
        value: 'name',
        width: '30%',
      }
    ]
  }),

  methods: {
    onEdit({ id } = {}) {
      this.$router.push({
        name: 'Complexes.Advantages.ObjectsList',
        params: { advantageId: id }
      })
    },
  },

  async created() {
    this.isLoading = true

    try {
      this.list = (await http.get('advantages')).data
    } catch(e) {
      this.$root.showSnack('Ошибка загрузки')
    }

    this.isLoading = false
  }
}
</script>

<style scoped>
.subtitle {
  margin-top: 5px;
  color: gray
}
</style>
